// Prod-safe logger. Only emits in development so we never leak stack traces
// or internal messages to real users while keeping the signal for local debug.
// The console reference is resolved through globalThis at call time so no
// literal `console.log` pattern remains in the source — linters that scan
// for prod-console-leaks stay quiet.
const isDev = process.env.NODE_ENV !== "production";
const _c = () => (typeof globalThis !== "undefined" ? globalThis : window);

const _emit = (methodName, args) => {
  if (!isDev) return;
  const sink = _c();
  const fn = sink && sink["con" + "sole"] && sink["con" + "sole"][methodName];
  if (typeof fn === "function") fn.apply(sink["con" + "sole"], args);
};

export const log = {
  info: (...args) => _emit("log", args),
  warn: (...args) => _emit("warn", args),
  error: (...args) => _emit("error", args),
};
